<template>
    <div>
        <el-dialog title="绑定辅助功能" :visible.sync="dialogVisible" width="500px">
            <el-table id="mxTable" ref="mxTable" :data="returnData.list" @selection-change="handleSelectionChange" height="400" border
                style="width: 100%" size="mini">
                <el-table-column type="selection" width="40"></el-table-column>
                <el-table-column min-width="120" prop="mdName" label="组件名称"></el-table-column>
                <el-table-column min-width="120" prop="mdSource" label="组件地址"></el-table-column>
                <!-- <el-table-column min-width="120" prop="mdSort" label="排序" sortable></el-table-column> -->
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: "modulelist",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dialogVisible: false,
            oldData: {},
            getRequestData: {
                mdName: "",
            },
            returnData: { list: [] },
            listdata: [],
            selectData: [],
        }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() { },
    //方法集合
    methods: {
        handleSelectionChange(val) {
            this.selectData = val
        },
        openBox(oldData) {
            this.dialogVisible = true
            this.oldData = oldData
            // this.init()
            this.desysModulequeryUserjurisdiction()
        },
        async desysModulequeryUserjurisdiction() {
            const params = {
                ids: [this.oldData.opmId]
            }
            const responseData = await this.$http.desysModulequeryUserjurisdiction(params)
            if (responseData.status == 200) {
                this.listdata = responseData.result
                this.init();
            }
        },
        async init() {
            const responseData = await this.$http.desysModulequeryModule(this.getRequestData)
            console.log(responseData);
            if (responseData.status == 200) {
                this.returnData.list = responseData.result
                if (this.listdata.length > 0) {
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.listdata.forEach(item => {
                                this.returnData.list.forEach(item1 => {
                                    if (item.mdId == item1.mdId) {
                                        console.log(this.$refs.mxTable);
                                        this.$refs.mxTable.toggleRowSelection(item1, true);
                                    }
                                })
                                this.selectData = this.listdata
                            })
                        }, 100)
                    })
                }
            }
        },
        async onSubmit() {
            if (this.selectData.length == 0) {
                return this.$message.error("请选择要提交的数据")
            }
            var arr = []
            this.selectData.forEach(item => {
                arr.push(item.mdId)
            })
            const params = {
                mdIds: arr,
                opmId: this.oldData.opmId
            }
            const responseData = await this.$http.desysModulesetUserjurisdiction(params)
            console.log(responseData);
            if (responseData.status == 200) {
                this.$message.success("操作成功")
                this.dialogVisible = false
            }
        },
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='css' scoped>
#mxTable {
    height: 400px;
}

::v-deep .el-dialog {
    margin-top: 5% !important;
}
</style>
